import React from "react";
import Instagram from "../assets/pictos/Instagram";
import Facebook from "../assets/pictos/Facebook";
import Twitter from "../assets/pictos/Twitter";
import Github from "../assets/pictos/Github";

const Footer = () => {
  const getTheCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <div className="px-8 pt-6 mt-auto">
      <footer className="bg-white">
        <div className="mx-auto max-w-7xl py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
          <div className="flex justify-center space-x-6 md:order-2">
            <a
              href="https://www.facebook.com/"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Facebook</span>
              <Facebook />
            </a>

            <a
              href="https://www.instagram.com/"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Instagram</span>
              <Instagram />
            </a>

            <a
              href="https://twitter.com/"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Twitter</span>
              <Twitter />
            </a>

            <a
              href="https://github.com/"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">GitHub</span>
              <Github />
            </a>
          </div>
          <div className="mt-8 md:order-1 md:mt-0">
            <p className="text-center text-base text-gray-400">
              &copy; {getTheCurrentYear()} Cryptools, All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
